import React from "react";
/* eslint-disable */
import {
    Box,
    TableBody, TableCell, TableContainer, TableHead, TableRow, Table,
} from '@material-ui/core';
import moment from "moment";


export default class ComponentToPrint extends React.Component {

    render() {
        const productData = this.props.productList;
        const searchQueryData = this.props.searchData;
        const totalValues = this.props.totalValues;
        return (
            <div>
                <br />
                <br />
                <h3><center><u>Farmer Wise Availability Report</u></center></h3>
                <div>&nbsp;</div>
                {/* <h4><center>Group - {searchQueryData.groupName} </center></h4>
                <h4><center>Fresh Collection Center - {searchQueryData.operationEntityID}</center></h4>
                <h4><center>{moment(searchQueryData.startDate).format("YYYY-MM-DD")} - {moment(searchQueryData.endDate).format("YYYY-MM-DD")}</center></h4> */}
                <div>&nbsp;</div>
                <Box minWidth={1050}>
                    <TableContainer style={{ marginLeft: '5px' }}>
                        <Table aria-label="caption table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align={'left'}>Farmer Name </TableCell>
                                    <TableCell align={'left'}>supplier Code </TableCell>
                                    <TableCell align={'left'}>Fresh Collection Center </TableCell>
                                    <TableCell align={'left'}>Product </TableCell>
                                    <TableCell align={'left'}>Crop Forecast date </TableCell>
                                    <TableCell align={'right'}>Quantity </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {productData.map((data, index) => (
                                    <TableRow key={index}>
                                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {data.firstName}
                                        </TableCell>
                                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {data.supplierCode}
                                        </TableCell>
                                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {data.factoryname}
                                        </TableCell>
                                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {data.productName}
                                        </TableCell>
                                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {new Date(data.cropForecastdate).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', minimumIntegerDigits: 2 })}
                                        </TableCell>
                                        <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {data.quantity}
                                        </TableCell>
                                    </TableRow>
                                ))}
                                <TableRow>
                                    <TableCell sx={{ fontWeight: "bold" }} >Total</TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell align="right" style={{ fontWeight: "bold" }}>
                                        {(totalValues.totalQuantity === 0 || totalValues.totalQuantity === "-")
                                            ? '-'
                                            : parseFloat(totalValues.totalQuantity).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </div>

        );
    }
}
